import { jsx as _jsx } from "react/jsx-runtime";
import { antdMessage } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import { GinStepItemFieldType, InitialGinStepApplicationItem, } from '@hellodarwin/core/lib/features/entities/gin-step-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Drawer from 'antd/es/drawer';
import { useState } from 'react';
import GinStepApplicationAssetUploadForm from './gin-step-application-asset-upload-form';
const GinStepAssetDrawer = ({ open, isLoading: isApplicationItemLoading, title, onClose, itemId, formApplicationId, applicationItem, operations, ginStepItemAssetType, ginStepItemCustomAssetType, companyName, grantName, onSuccess, }) => {
    var _a;
    const { t } = useTranslations();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isLoading = isApplicationItemLoading || isSubmitting;
    const oldAsset = (_a = applicationItem === null || applicationItem === void 0 ? void 0 : applicationItem.item_asset_application) === null || _a === void 0 ? void 0 : _a.file_response;
    const handleSaveAsset = async (fileSubmission) => {
        var _a;
        setIsSubmitting(true);
        try {
            const asset = await (async () => {
                if (fileSubmission.newFile) {
                    const request = {
                        file_name: fileSubmission.display_name || fileSubmission.newFile.name,
                        file_description: '',
                        asset_id: '',
                        version: '',
                        gin_step_item_id: itemId,
                        records: [
                            {
                                record_id: operations.assets.programId,
                                record_type: 'application',
                            },
                        ],
                    };
                    return operations.assets.uploadApplicationAsset(request, fileSubmission.newFile);
                }
                if (fileSubmission.copyFile) {
                    const request = {
                        asset_id: fileSubmission.copyFile.asset_id,
                        file_name: fileSubmission.display_name,
                        file_description: '',
                        version: '',
                        gin_step_item_id: itemId,
                        records: [
                            {
                                record_id: operations.assets.programId,
                                record_type: 'application_item',
                            },
                        ],
                    };
                    return operations.assets.copyApplicationAsset(request);
                }
                throw new Error('missing asset submission payload');
            })();
            const newApplicationItem = Object.assign(Object.assign({}, (applicationItem || InitialGinStepApplicationItem)), { item_application_id: (applicationItem === null || applicationItem === void 0 ? void 0 : applicationItem.item_application_id) || '', item_id: itemId, form_application_id: formApplicationId, field_type: GinStepItemFieldType.ASSET_APPLICATION, item_asset_application: {
                    item_asset_application_id: ((_a = applicationItem === null || applicationItem === void 0 ? void 0 : applicationItem.item_asset_application) === null || _a === void 0 ? void 0 : _a.item_asset_application_id) || '',
                    item_id: itemId,
                    name: fileSubmission.display_name,
                    file_response: asset,
                    file_upload: undefined,
                } });
            const form = await operations.submitApplicationItem(newApplicationItem, false, false);
            if (form.program_status_trigger) {
                operations.triggerProgramStatusDialog(form.program_status_trigger);
            }
            await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
        }
        catch (error) {
            console.error(error);
            antdMessage.error(t('gin_steps|step_asset_create_error'));
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const handleModifyAsset = async (name) => {
        if (!(oldAsset === null || oldAsset === void 0 ? void 0 : oldAsset.asset_id))
            return;
        setIsSubmitting(true);
        try {
            const modifiedAsset = Object.assign(Object.assign({}, oldAsset), { display_name: name });
            await operations.assets.renameApplicationAsset(modifiedAsset);
            antdMessage.success('Asset modification successful');
            await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
        }
        catch (_error) {
            antdMessage.error('Asset modification failed');
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (_jsx(Drawer, { title: title, placement: "right", width: 500, closable: !isLoading, maskClosable: !isLoading, onClose: () => {
            if (!isLoading)
                onClose();
        }, open: open, children: _jsx(GinStepApplicationAssetUploadForm, { handleAfterFinish: onClose, handleSaveAsset: handleSaveAsset, asset: oldAsset, handleModifyAsset: handleModifyAsset, isDrawerOpen: open, isLoading: isLoading, companyName: companyName, grantName: grantName, ginAssetType: ginStepItemAssetType, ginCustomAssetType: ginStepItemCustomAssetType, fetchRelatedAssets: operations.assets.fetchGinStepApplicationRelatedAssets }) }));
};
export default GinStepAssetDrawer;
